<template>
  <div class="main">
    <!-- 菜单 -->
    <my_menu2 page_name="我的项目v2" back_type="close" back_icon="md-close"></my_menu2>


    <div class="main2">
      <div v-if="left_menu" class="left_menu_if">
        <div class="project_left_box">
          <Spin fix v-if="table_loading"></Spin>
          <div class="left_project_tab">
            <Tabs v-model="operation_status" @on-click="tabs_click">
              <TabPane label="合作中项目" name="0"></TabPane>
              <TabPane label="停止合作项目" name="1"></TabPane>
            </Tabs>
          </div>
          <div class="search_div">
            <Input size="small" @on-search="search" v-model="search_project_name"
              style="width: 240px; margin-right: 10px" search enter-button placeholder="搜索项目名称" />
          </div>
          <div class="left_project_div_list">
            <div v-for="(item, i) in table_data" :key="i">
              <div :class="i != project_current_index
                ? 'project_list_div'
                : 'project_list_div_click'
                " @click="click_left_project(item, i)">
                <div>
                  <div class="top_div">
                    <div :class="i != project_current_index ? 'project_number' : 'project_number2'
                      ">
                      {{ i + 1 + page * limit - limit }}
                    </div>
                    <div>
                      <span class="project_name_text">{{ item.project_name }}</span>
                    </div>
                  </div>

                  <div class="project_full_name">
                    全称:{{ project_name_long_slice(item.project_full_name) }}
                  </div>
                  <div class="project_full_name">
                    财务:{{ project_name_long_slice(item.project_group_name) }}
                  </div>
                </div>

              </div>



            </div>
          </div>
          <div class="project_page">
            <span style="font-size:13px;color:#888">
              共{{ total_count }}条
            </span>

            <Page :modelValue="page" :total="total_count" simple page-size="20" @on-change="page_change" />
          </div>
        </div>
      </div>
      <div :class="left_menu ? 'project_right_box' : 'project_right_box2'">
        <div class="right_project_name">
          <div></div>
          <div class="project_name_div2">
            <span class="project_type_tag" :style="'background:' + project_current_item.project_type_color">
              {{ project_current_item.project_type }}</span>{{ project_current_item.project_name }}
          </div>

          <span v-if="project_current_item.operation_status == '0'" class="tingzhi_hezuo"
            @click="project_stop">更新为停止</span>
          <span v-if="project_current_item.operation_status == '1'" class="tingzhi_hezuo"
            @click="project_start">更新为正常</span>
        </div>

        <div class="project_right_inner">


          <div class="project_right_box_menu">
            <div @click="click_right_menu(item, i)" :class="i == right_menu_index
              ? 'project_right_box_menu_list2'
              : 'project_right_box_menu_list'
              " v-for="(item, i) in right_menu_list" :key="i"
              :style="i == right_menu_index ? 'background:' + item.color : ''">
              {{ item.name }}
              <div class="menu_hot" v-if="item.is_hot == 1">hot</div>
            </div>
          </div>
          <div class="right_right" v-if="JSON.stringify(project_current_item) != '{}'">
            <check ref="check" @change="check_change"></check>


            <div v-show="right_menu_list[right_menu_index]['type'] == 'mianshi'">
              <div class="line_icon_title">
                <div class="line_icon"></div>
                <div class="line_name">项目本周需求</div>
              </div>
              <div class="week_need">
                项目本周需求：<span class="current_need_count" @click="click_update_need_count(project_current_item)">{{
                  project_current_item.need_count }}人（点击更新）</span>
              </div>
              <div class="need_job">
                <div v-for="(need_item, need_index) in project_current_item.need_job_data" :key="need_index"
                  class="need_job_div2">
                  <div>
                    {{ need_item.job_name }} · {{ need_item.need_count }}人 · {{ need_item.salary }}/{{
                      need_item.salary_type }}
                  </div>
                </div>
              </div>
              <div style="height: 10px"></div>
              <div class="line_icon_title">
                <div class="line_icon"></div>
                <div class="line_name">长期工 - 面试流程</div>
              </div>
              <div style="margin-top:5px">
              </div>
              <div class="mianshi_box">
                <div class="mianshi_box2" @click="click_count(project_current_item, '待面试')">
                  <div>
                    <CountUp :end="interview_mainshi_count_dict.daimianshi" :duration="1" ref="count" v-font="18" />
                  </div>
                  <div class="mianshi_box2_name">待面试</div>
                </div>
                <div class="mianshi_box2" @click="click_count(project_current_item, '面试中')">
                  <div>
                    <CountUp :end="interview_mainshi_count_dict.mianshizhong" :duration="1" ref="count" v-font="18" />
                  </div>
                  <div class="mianshi_box2_name">面试中</div>
                </div>
                <div class="mianshi_box2" @click="click_count(project_current_item, '待入职')">
                  <div>
                    <CountUp :end="interview_mainshi_count_dict.dairuzhi" :duration="1" ref="count" v-font="18" />
                  </div>
                  <div class="mianshi_box2_name">待入职</div>
                </div>
                <div class="mianshi_box2" @click="click_count(project_current_item, '入职')">
                  <div>
                    <CountUp :end="interview_mainshi_count_dict.ruzhi" :duration="1" ref="count" v-font="18" />
                  </div>
                  <div class="mianshi_box2_name">入职</div>
                </div>
                <div class="mianshi_box2" @click="click_count(project_current_item, '离职')">
                  <div>
                    <CountUp :end="interview_mainshi_count_dict.lizhi" :duration="1" ref="count" v-font="18" />
                  </div>
                  <div class="mianshi_box2_name">离职</div>
                </div>
              </div>
              <div class="line_icon_title">
                <div class="line_icon"></div>
                <div class="line_name">长期工 - 花名册</div>
              </div>
              <div style="margin-top:5px">
                <div class="jiance_div"
                  v-if="resume_check_dict.resume_error_count > 0 || resume_check_dict.unsigned_idcard_count > 0">
                  <Icon type="md-alert" color="red" size="16" style="margin-right:3px" />在职员工信息检测,点击数字查看详情：
                  <div v-if="resume_check_dict.resume_error_count > 0"><span class="jiance_number"
                      @click="resume_idcard_check_show = true">
                      <Icon type="md-contacts" />{{
                        resume_check_dict.resume_error_count }}人
                    </span>身份证信息不完整。</div>
                  <div v-if="resume_check_dict.unsigned_idcard_count > 0" @click="resume_contract_check_show = true">
                    <span class="jiance_number">
                      <Icon type="md-contacts" />{{
                        resume_check_dict.unsigned_idcard_count }}人
                    </span>合同未签署或已过期。
                  </div>
                </div>
                <div v-else class="jiance_div2">
                  <span class="jiance_number2">
                    <Icon type="md-alert" color="blue" size="16" style="margin-right:3px" />
                    666哇~ 身份证与合同都很完善，没有检测到不完整情况，请继续保持！
                  </span>🤙🤙🤙
                </div>

              </div>

              <div class="mianshi_box">
                <div class="mianshi_box2" @click="click_roster(project_current_item, 0)">
                  <div>
                    <CountUp :end="interview_mainshi_count_dict.ruzhi" :duration="1" ref="count" v-font="18" />
                  </div>
                  <div class="mianshi_box2_name">在职花名册</div>
                </div>
                <div class="mianshi_box2" @click="click_roster(project_current_item, 1)">
                  <div>
                    <CountUp :end="interview_mainshi_count_dict.lizhi" :duration="1" ref="count" v-font="18" />
                  </div>
                  <div class="mianshi_box2_name">离职花名册</div>
                </div>
                <div class="mianshi_box2" @click="click_swiper_idcard(project_current_item)">
                  <div>
                    <span class="iconfont iconsfz1"></span>
                  </div>
                  <div class="mianshi_box2_name">刷身份证(NFC)</div>
                </div>
              </div>

              <div class="line_icon_title">
                <div class="line_icon"></div>
                <div class="line_name">短期工 - 花名册</div>
              </div>
              <div style="margin-top:5px">
              </div>
              <div class="mianshi_box">
                <div class="mianshi_box2" @click="click_duanqigong(project_current_item, 'daiqueren')">
                  <div>
                    <CountUp :end="interview_mainshi_count_dict.dqg_daiqueren" :duration="1" ref="count" v-font="18" />
                  </div>
                  <div class="mianshi_box2_name">待确认</div>
                </div>
                <div class="mianshi_box2" @click="click_duanqigong(project_current_item, 'zaizhi')">
                  <div>
                    <CountUp :end="interview_mainshi_count_dict.dqg_zaizhi" :duration="1" ref="count" v-font="18" />
                  </div>
                  <div class="mianshi_box2_name">在职花名册</div>
                </div>
                <div class="mianshi_box2" @click="click_duanqigong(project_current_item, 'lizhi')">
                  <div>
                    <CountUp :end="interview_mainshi_count_dict.dqg_lizhi" :duration="1" ref="count" v-font="18" />
                  </div>
                  <div class="mianshi_box2_name">离职花名册</div>
                </div>
              </div>
              <div class="line_icon_title">
                <div class="line_icon"></div>
                <div class="line_name">二维码信息收集</div>
              </div>
              <div>
                <div class="mianshi_box_form" @click="universal_form(project_current_item)">
                  <div class="mianshi_box2_name">去创建</div>
                </div>
              </div>
              <div style="margin-top:5px">
              </div>
              <interview_data ref="interview_data"></interview_data>
              <project_setting ref="project_setting"></project_setting>
            </div>
            <div v-show="right_menu_list[right_menu_index]['type'] == 'basic'">

              <project_basic_info ref="project_basic_info" @change="basic_info_change"
                @project_type_change="project_type_change"></project_basic_info>
            </div>
            <div v-show="right_menu_list[right_menu_index]['type'] == 'jiezhi'">
              <jiezhi_data ref="jiezhi_data"></jiezhi_data>
            </div>
            <div v-show="right_menu_list[right_menu_index]['type'] == 'hetong'">
              <contract_data ref="contract_data"></contract_data>
              <insurance_data ref="insurance_data"></insurance_data>
            </div>
            <div v-show="right_menu_list[right_menu_index]['type'] == 'kaipiao'">
              <kaipiao ref="kaipiao"></kaipiao>
              <project_payment ref="project_payment"></project_payment>
            </div>
            <div v-show="right_menu_list[right_menu_index]['type'] == 'sushe'">
              <project_dormitory ref="project_dormitory"></project_dormitory>
            </div>
            <div v-show="right_menu_list[right_menu_index]['type'] == 'cloud_disk'">
              <cloud_disk ref="cloud_disk"></cloud_disk>
            </div>
          </div>
        </div>
      </div>

      <Modal v-model="need_update_show" title="周需求更新" :footer-hide="true" width="500">
        <div class="need_update_title">该项目本周需求，对外公开展示，请填写真实招聘信息!</div>
        <!-- <div class="people_count_div">
          <span style="width: 100px">需求人数：</span>
          <Input v-model="update_week_count" />
        </div> -->

        <div class="need_job_main">
          <div v-for="(item, i) in update_need_job_list" :key="i" class="need_job_div">
            <div class="need_job_index">
              {{ i + 1 }}
            </div>
            <div class="need_job_box">
              <div class="need_job_inner_div">
                <div class="need_job_title">岗位名称：</div>
                <Input size="small" v-model="item.job_name" placeholder="输入岗位名称，例：叉车工" style="width: 250px" />
              </div>
              <div class="need_job_inner_div">
                <div class="need_job_title">岗位需求人数：</div>
                <InputNumber size="small" v-model="item.need_count" />
                <span style="font-size: 12px;color:#888;">&nbsp;人</span>

              </div>
              <div class="need_job_inner_div">
                <div class="need_job_title">岗位工资标准：</div>
                <InputNumber size="small" v-model="item.salary" />
                <span style="font-size: 12px;color:#888;">&nbsp;元</span>
                <span>&nbsp;&nbsp;/&nbsp;&nbsp;</span>
                <Select size="small" v-model="item.salary_type" style="width:100px">
                  <Option v-for="item in need_salary_type_list" :value="item.value" :key="item.value">{{ item.label }}
                  </Option>
                </Select>

              </div>
            </div>

            <div>
              <div class="del_job" @click="del_need_job(item, i)">
                <Icon type="ios-trash-outline" color="white" size="18" />
                <span style="font-size: 13px;">删除</span>
              </div>
            </div>

          </div>
          <div class="need_job_btn_div" @click="add_nedd_job">
            <Icon type="ios-add-circle-outline" size="18" />&nbsp;添加岗位
          </div>
        </div>

        <div class="need_button_div">
          <Button type="primary" style="font-size: 12px" @click="update_need_data_first">确认更新</Button>
        </div>
      </Modal>

      <!-- <Modal v-model="project_introduction_show" title="项目介绍完善率过低" :footer-hide="true" width="400">
        <div class="project_introduction">
          当前项目【{{ current_item.project_name }}】，项目介绍完善率：{{
            current_item.percentage_of_perfection
          }}%
        </div>

        <div class="need_update_title">
          检测到当前项目介绍完善率小于80%，完善后有助招聘人员更好的了解项目情况，请先点击前往完善一下!
        </div>

        <div class="need_button_div">
          <Button style="font-size: 12px; margin-right: 10px" @click="to_project_interview">等会再完善（剩余次数{{
            current_item.max_skip_wanshan - current_item.current_skip_wanshan
          }}）</Button>
          <Button type="primary" style="font-size: 12px" @click="to_project_introduction">去完善项目介绍</Button>
        </div>
      </Modal> -->
    </div>
    <Drawer title="员工身份证未完善详情" v-model="resume_idcard_check_show" width="400px">
      <div>
        <Table :columns="resume_columns" size="small" :data="resume_check_dict.resume_basic_list"></Table>

      </div>
    </Drawer>

    <Drawer title="员工合同未签署详情" v-model="resume_contract_check_show" width="600px">
      <div>
        <Table :columns="resume_contract_columns2" size="small" :data="resume_check_dict.unsigned_item_list">
          <template #action="{ row }">
            <span class="contract_span" @click="click_contract_item(row)">查看合同</span>
          </template>

        </Table>
      </div>
    </Drawer>
  </div>
</template>

<script>
import my_menu from "@/component/menu/menu.vue";
import my_menu2 from "@/component/menu/menu2.vue";
import { http, open_new_page } from "@/utils/http.js";
import merge from "webpack-merge";
import intro1 from "./component/intro/intro1.vue";

import project_basic_info from "@/views/workbench/project_detail/component/project_basic_info.vue";
import jiezhi_data from "@/views/workbench/project_detail/component/jiezhi_data.vue";
import contract_data from "@/views/workbench/project_detail/component/contract_data.vue";
import insurance_data from "@/views/workbench/project_detail/component/insurance_data.vue";
import project_payment from "@/views/workbench/project_detail/component/payment.vue";
import kaipiao from "@/views/workbench/project_detail/component/kaipiao.vue";
import interview_data from "@/views/workbench/project_detail/component/interview_data.vue";
import project_setting from "@/views/workbench/project_detail/component/project_setting.vue";
import check from "./component/check.vue";
import project_dormitory from '@/views/workbench/project_detail/component/project_dormitory.vue'
import cloud_disk from '@/views/workbench/my_project/component/cloud_disk.vue'

export default {
  components: {
    my_menu,
    my_menu2,
    intro1,
    project_basic_info,
    jiezhi_data,
    contract_data,
    insurance_data,
    project_payment,
    kaipiao,
    interview_data,
    project_setting,
    check,
    project_dormitory,
    cloud_disk
  },

  data() {
    return {
      textTitle: "项目列表",
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度

      left_menu: true,

      //系统列表
      table_data: [],
      columns: [],
      table_loading: false,
      page: 1,

      right_menu_index: 0,
      right_menu_list: [
        {
          name: "面试/入职",
          type: "mianshi",
          color: "#0466dd",
        },
        {
          type: "basic",
          name: "项目信息",
          color: "#ef7a82",
        },
        {
          type: "jiezhi",
          name: "借支/关系解除",
          color: "#33CC33",
        },
        {
          type: "hetong",
          name: "合同/保险数据",
          color: "#e51818",
        },
        {
          type: "kaipiao",
          name: "开票/发薪",
          color: "#f17409",
        },
        {
          type: "sushe",
          name: "员工宿舍",
          color: "#f17409",
        },
        {
          type: "cloud_disk",
          name: "项目云盘",
          color: "#08e083",
          is_hot: 1
        },
      ],

      current_project_id: "",
      tabs_append: "",
      total_count: 0,
      limit: 20,
      table_loading: false,
      project_current_index: 0,
      project_current_item: {},

      project_name: "",
      project_id: "",
      search_project_name: "",

      guidance_type_id: "",

      need_update_show: false,
      update_week_count: "",
      update_need_job_list: [

      ],
      need_salary_type_list: [
        {
          value: '小时',
          label: '小时'
        },
        {
          value: '天',
          label: '天'
        },
        {
          value: '月',
          label: '月'
        }, {
          value: '件',
          label: '件'
        },

      ],

      update_need_item: {},

      operation_status: "0",
      table_selection_list: [],

      project_introduction_show: false,
      current_item: {},
      interview_status: 0,
      interview_mainshi_count_dict: {
        daimianshi: -1,
        mianshizhong: -1,
        dairuzhi: -1,
        ruzhi: -1,
        lizhi: -1,
        dqg_daiqueren: -1,
        dqg_zaizhi: -1,
        dqg_lizhi: -1,
      },


      //简历检测
      resume_check_dict: {},
      resume_columns: [{
        'title': '姓名',
        'key': 'name'
      },
      {
        'title': '身份证实名',
        'key': 'is_certification_fmt'
      },
      {
        'title': '身份证照片',
        'key': 'idcard_img_status_fmt'
      }],
      resume_idcard_check_show: false,

      resume_contract_check_show: false,

      resume_contract_columns2: [{
        'title': '姓名',
        'key': 'name',
        'width': 120
      },
      {
        'title': '身份证号',
        'key': 'idcard'
      },
      {
        'title': '状态说明',
        'key': 'status'
      },
      {
        'title': '操作',
        'slot': 'action',
        'width': 100
      }
      ],



    };
  },

  created() {


    var query = this.$route.query;
    var list_page = query.list_page;
    var list_index = query.list_index;

    if (list_index) {
      this.project_current_index = list_index;
      this.updateQueryParam('list_index', list_index)
    } else {
      this.updateQueryParam('list_index', '0')
    }
    if (list_page) {
      this.page = list_page;
      this.updateQueryParam('list_page', list_page)
    } else {
      this.updateQueryParam('list_page', '1')
    }

  },

  mounted() {
    var that = this;



    var query = this.$route.query;
    var project_id = query.project_id;
    if (project_id) {
      this.current_project_id = project_id;
      this.left_menu = false
    } else {
      this.left_menu = true
    }

    var tabs_append = query.tabs_append;
    if (tabs_append) {
      this.tabs_append = tabs_append;
    } else {
      this.get_my_project_list();
    }

    var project_name = query.project_name;
    if (project_name) {
      this.project_name = project_name;
    }

    this.update_tabs();

    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;
        window.fullWidth = document.documentElement.clientWidth;
        that.windowHeight = window.fullHeight; // 高
        that.windowWidth = window.fullWidth; // 宽
      })();
    };
  },

  methods: {

    del_need_job(item, index) {
      this.update_need_job_list.splice(index, 1)
    },

    click_contract_item(row) {
      var url = 'https://contract.daxiangsys.com/contract_manage/search/detail?name=&phone=&idcard=' + row.idcard + '&project_id=' + row.project_id
      open_new_page(url)
    },


    check_change(status) {

      console.log(status)
      if (status == 'week_need_status') {
        // alert('周需求更新')
        this.click_update_need_count(this.project_current_item)

      }
      if (status == 'project_job') {
        // this.$refs.project_job.click_add_job();
        this.$refs.project_basic_info.click_add_job(this.project_current_item.project_id);
      }

      if (status == 'project_contract') {
        this.$refs.project_basic_info.click_business_contract(this.project_current_item.project_id);
      }
      if (status == 'percentage_of_perfection') {
        this.$refs.project_basic_info.to_project_introduction(this.project_current_item.project_id);
      }
      if (status == 'project_subject') {
        this.$refs.project_basic_info.open(this.project_current_item.project_id);

        this.$refs.project_basic_info.update_subject();
      }
      if (status == 'project_place') {
        this.$refs.project_basic_info.open(this.project_current_item.project_id);

        this.$refs.project_basic_info.update_place_click();
      }
      if (status == 'dormitory') {
        this.$refs.project_dormitory.click_add_dormitory(this.project_current_item.project_id)

      }
      if (status == 'market_share') {
        // 市占率
        this.$refs.project_basic_info.open(this.project_current_item.project_id);
        this.$refs.project_basic_info.click_add_market_share(this.project_current_item.project_id);

      }
      if (status == 'project_data_user') {
        // 员工数据用户
        this.$refs.project_basic_info.open(this.project_current_item.project_id);
        this.$refs.project_basic_info.open_drawer(this.project_current_item.project_id);

      }
      if (status == 'gaozhishu_count') {
        // 员工数据用户
        this.$refs.project_basic_info.open(this.project_current_item.project_id);
        this.$refs.project_basic_info.click_add_gaozhishu(this.project_current_item.project_id);

      }


    },
    click_duanqi_roster(item, status) {
      // this.$Message.warning("正在努力开发中，近期上线，敬请期待!");
      console.log(item);
      this.$router.push({
        path: "/roster_manage/duanqi_roster",
        query: {
          project_id: item.project_id,
          project_name: item.project_name,
          job_status: status,
        },
      });
    },
    click_right_menu(item, i) {
      this.right_menu_index = i;
      console.log(this.project_current_item);
      console.log(this.$refs.project_basic_info);

      //
      console.log(123, item);

      // this.$refs.project_basic_info.get_data(this.project_current_item.project_id);
      if (item.type == "mianshi") {
        console.log("面试入职");
        this.update_interview_num();
        this.$refs.interview_data.open(
          this.project_current_item.project_id,
          this.project_current_item.project_name
        );

        this.$refs.project_setting.open(
          this.project_current_item.project_id,
          this.project_current_item.project_name
        );
        this.$refs.project_job.open(
          this.project_current_item.project_id,
          this.project_current_item.project_name
        );
      }
      if (item.type == "basic") {
        this.$refs.project_basic_info.open(this.project_current_item.project_id);
      }
      if (item.type == "jiezhi") {
        console.log("刷新员工借支");
        // 员工借支
        this.$refs.jiezhi_data.open(
          this.project_current_item.project_id,
          this.project_current_item.project_name
        );
      }
      if (item.type == "hetong") {
        // 员工合同数据
        this.$refs.contract_data.open(
          this.project_current_item.project_id,
          this.project_current_item.project_name
        );
        this.$refs.insurance_data.open(
          this.project_current_item.project_id,
          this.project_current_item.project_name
        );
      }
      if (item.type == "kaipiao") {
        // 开票
        this.$refs.kaipiao.open(this.project_current_item.project_id);
        this.$refs.project_payment.open(
          this.project_current_item.project_id,
          this.project_current_item.project_name
        );
      }
      if (item.type == 'sushe') {
        this.$refs.project_dormitory.open(this.project_current_item.project_id)
      }
      if (item.type == 'cloud_disk') {
        this.$refs.cloud_disk.open(this.project_current_item.project_id)
      }
      // var that = this
      // setTimeout(function(){
      //   this.$refs.project_basic_info.open();
      // },1000)
    },

    table_selection_change(e) {
      this.table_selection_list = e;
    },

    //项目停止
    project_stop() {
      var that = this;
      this.$Modal.confirm({
        title: "提示",
        content: "正在停止项目，停止后可在停止项目列表中查看或重新启动，是否继续？",
        onOk: () => {
          that.stop_http();
        },
        onCancel: () => { },
      });
    },



    stop_http() {
      var that = this;

      var obj = {
        project_id_list: [this.project_current_item.project_id],
      };
      http("post", process.env.VUE_APP_HOST + "/my_project/stop_project", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.get_my_project_list();
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.table_selection_list = [];
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //项目开启
    project_start() {
      var that = this;

      var that = this;
      this.$Modal.confirm({
        title: "提示",
        content: "正在启动项目，启动后可在正常项目列表中查看或重新停止，是否继续？",
        onOk: () => {
          that.start_http();
        },
        onCancel: () => { },
      });
    },

    start_http() {
      // if (this.table_selection_list.length == 0) {
      //   this.$Message.error("请至少选择一个项目");
      //   return;
      // }

      // var project_id_list = [];
      // for (var i = 0; i < this.table_selection_list.length; i++) {
      //   var pid = this.table_selection_list[i]["project_id"];
      //   project_id_list.push(pid);
      // }

      var that = this;

      var obj = {
        project_id_list: [this.project_current_item.project_id],
      };
      http("post", process.env.VUE_APP_HOST + "/my_project/start_project", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.table_selection_list = [];
            that.get_my_project_list();
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    update_need_data_first() {
      // if (this.update_week_count == "") {
      //   this.$Message.error("请输入周需求人数");
      //   return;
      // }
      var that = this;
      // var reg = /^[0-9]+$/;
      // var result = reg.test(this.update_week_count);
      // console.log(result);
      // console.log(this.update_week_count);
      // if (!result) {
      //   this.$Message.error("请输入整数");
      //   return;
      // }
      // var total_count = 0
      // for(var i =0;i<this.update_need_job_list.length;i++){
      //   var count = this.update_need_job_list[i]['need_count']
      //   total_count+=count
      // }

      if (this.update_need_job_list.length == 0) {
        this.$Modal.confirm({
          title: "提示",
          content: "<p>当前周需求数为0，真的要更新为无需求吗？</p>",
          onOk: () => {
            that.update_need_data();
          },
          onCancel: () => { },
        });
      } else {
        that.update_need_data();
      }

    },

    //需求数据更新
    update_need_data() {
      var that = this;

      var obj = {
        project_id: this.update_need_item.project_id,
        need_job_list: this.update_need_job_list
      };
      http(
        "post",
        process.env.VUE_APP_HOST +
        "/my_project/project_detail/need_data/week_need_update",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.get_my_project_list();
            that.need_update_show = false;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    search() {
      this.page = 1;
      this.project_current_index = 0;
      this.get_my_project_list();
    },

    updateQueryParam(key, value) {
      var that = this
      setTimeout(() => {
        // 创建一个新的查询参数对象
        let newQuery = { ...that.$route.query };
        // 设置或修改查询参数
        newQuery[key] = value;
        // 使用`this.$router.push`来更新URL的查询参数
        that.$router.push({ path: that.$route.path, query: newQuery });
      }, 50);
    },

    page_change(e) {
      this.page = e;
      this.project_current_index = 0;
      this.updateQueryParam('list_index', 0)
      this.table_selection_list = [];
      this.get_my_project_list();
      this.updateQueryParam('list_page', e)

    },

    click_duanqigong(row, status) {
      var project_id = row.project_id;

      open_new_page(
        "/roster_manage/duanqi_roster?project_id=" +
        project_id +
        "&job_status=" +
        status +
        "&project_name=" +
        row.project_name
      );
    },

    click_roster(row, status) {
      console.log(row);
      var project_id = row.project_id;
      open_new_page(
        "/roster_manage/detail?project_id=" +
        project_id +
        "&job_status=" +
        status +
        "&project_name=" +
        row.project_name
      );
    },

    update_tabs() {
      if (this.tabs_append == "") {
        return;
      }
      this.tabs_item_list.push({ name: this.tabs_append });
      this.tabs_index = String(this.tabs_item_list.length - 1);
    },

    click_count(item, status) {
      this.current_item = item;
      this.interview_status = status;
      var update_need_flag = item.update_need_flag;
      var that = this;
      var percentage_of_perfection = item.percentage_of_perfection;
      console.log(item);
      // console.log('周需求更新', update_need_flag)
      if (update_need_flag) {
        // 判断是否有完善项目介绍,排除挂靠-社保代理
        
          console.log("完善率可以");
          var route = that.$route;
          var path =
            route.path +
            "/detail" +
            "?tabs_append=" +
            that.interview_status +
            "&project_id=" +
            that.current_item.project_id +
            "&project_name=" +
            that.current_item.project_name;
          // // 打开新窗口1
          open_new_page(path, "_blank");
        
      } else {
        this.update_need_item = item;
        // this.update_week_count = item.need_count;
        this.need_update_show = true;
      }
    },

    // 跳转到项目介绍
    to_project_introduction() {
      open_new_page("/project_introduction?project_id=" + this.current_item.project_id);
    },

    // 跳转到面试流程
    to_project_interview() {
      this.skip_wanshan(this.current_item.project_id);
    },

    //点击更新周需求

    click_update_need_count(item) {
      this.update_need_item = item;
      // this.update_week_count = item.need_count;
      this.need_update_show = true;
    },

    click_project_data(item) {
      // var route = this.$route
      var path = "/workbench/project_detail" + "?project_id=" + item.project_id;
      // // 打开新窗口
      open_new_page(path);
    },

    //点击项目名称
    click_project_name(item, status) {
      this.current_project_id = item.project_id;
      this.$router.push({
        query: merge(this.$route.query, {
          tabs_append: status,
          project_id: this.current_project_id,
        }),
      });
      this.tabs_append = status;

      this.update_tabs();
    },

    tabs_click(item) {
      this.page = 1;
      this.get_my_project_list();
      // console.log(item)
      // console.log(e)

      // if (e == 0) {
      //     this.tabs_item_list = [{ name: '项目列表' }]
      //     this.tabs_index = 0
      //     // 置0
      //     this.daimianshi_show = false
      //     this.mianshizhong_show = false
      //     this.$router.push({
      //         query: merge({}, {})
      //     })
      //     this.get_my_project_list()
      // }
    },

    //入职信息完整检测
    entry_resume_status_check() {
      var that = this;
      console.log("入职信息完整检测");
      var obj = {
        project_id: this.project_current_item.project_id,
      };
      http("post", process.env.VUE_APP_HOST + "/my_project/check_entry_people_information", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.resume_check_dict = res.data
          }

        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    update_interview_num() {
      var that = this;
      setTimeout(function () {
        that.get_my_project_count_v2("daimianshi");
      }, 800);
      setTimeout(function () {
        that.get_my_project_count_v2("mianshizhong");
      }, 500);
      setTimeout(function () {
        that.get_my_project_count_v2("dairuzhi");
      }, 800);
      setTimeout(function () {
        that.get_my_project_count_v2("ruzhi");
      }, 1000);
      setTimeout(function () {
        that.get_my_project_count_v2("lizhi");
      }, 1200);
      setTimeout(function () {
        that.get_my_project_count_v2("dqg_daiqueren");
      }, 1000);
      setTimeout(function () {
        that.get_my_project_count_v2("dqg_zaizhi");
      }, 1000);
      setTimeout(function () {
        that.get_my_project_count_v2("dqg_lizhi");
      }, 1000);
      setTimeout(function () {
        that.entry_resume_status_check();
      }, 1000);



      setTimeout(function () {
        that.$refs.interview_data.open(
          that.project_current_item.project_id,
          that.project_current_item.project_name
        );

        that.$refs.project_setting.open(
          that.project_current_item.project_id,
          that.project_current_item.project_name
        );

        that.$refs.project_job.open(
          that.project_current_item.project_id,
          that.project_current_item.project_name
        );
      }, 500);
    },

    //获取项目列表
    get_my_project_list() {
      var that = this;
      var obj = {
        page: Number(this.page),
        project_name: this.search_project_name,
        project_id: this.current_project_id,
        operation_status: this.operation_status,
      };
      this.table_loading = true;
      http("post", process.env.VUE_APP_HOST + "/my_project/project_list", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.table_data = res.data.project_list;
            that.columns = res.data.columns;
            that.limit = res.data.limit;
            that.total_count = res.data.total_count;
            that.guidance_type_id = res.data.guidance_type_id;

            var project_id_list = [];
            for (let i = 0; i < that.table_data.length; i++) {
              project_id_list.push(that.table_data[i]["project_id"]);
            }
            if (that.table_data.length > 0) {
              that.project_current_item = that.table_data[that.project_current_index];
              console.log(that.project_current_item,666)
              // 回显需求岗位列表
              if (that.project_current_item.need_job_data.length > 0) {
                that.update_need_job_list = JSON.parse(JSON.stringify(that.project_current_item.need_job_data))
              } else {
                that.update_need_job_list = [{ job_name: '', need_count: 15, salary_type: '小时', salary: 20 }]
              }

              setTimeout(() => {
                that.$refs.check.open(that.project_current_item.project_id)
              }, 100);



              that.update_interview_num();
              // that.$refs.check.open(that.project_current_item.project_id)

            } else {
              that.project_current_item = {};
            }


            // if (res.data.guidance_status) {
            //   setTimeout(() => {
            //     that.$refs.intro1.open();
            //   }, 4000);
            // }

            // 打开
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.table_loading = false;
        })
        .catch((res) => {
          that.table_loading = false;

          console.log(res, "请求出错");
        });
    },

    basic_info_change(e) {
      console.log(e)

    },
    project_type_change(e) {
      console.log('项目性质更新', e)
      this.project_current_item.project_type = e
    },

    //跳过完善
    skip_wanshan(project_id) {
      var that = this;
      var obj = {
        project_id: project_id,
      };
      http("post", process.env.VUE_APP_HOST + "/my_project/buwanshan", obj, true)
        .then((res) => {
          if (res.code == 0) {
            var route = that.$route;
            var path =
              route.path +
              "/detail" +
              "?tabs_append=" +
              that.interview_status +
              "&project_id=" +
              that.current_item.project_id +
              "&project_name=" +
              that.current_item.project_name;
            // // 打开新窗口1
            open_new_page(path, "_blank");

            // 打开
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //获取项目列表-数量
    get_my_project_count(project_id_list, status) {
      var that = this;
      var obj = {
        project_id_list: project_id_list,
        status: status,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_interview_count",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            var data = res.data.data_dict;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //获取项目列表-数量
    get_my_project_count_v2(status) {
      var that = this;
      var obj = {
        project_id: this.project_current_item.project_id,
        status: status,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_interview_count_v2",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            var data = res.data.data_dict;
            var count = data[this.project_current_item.project_id];
            if (count == undefined) {
              count = 0;
            }
            console.log(status, count);
            that.interview_mainshi_count_dict[status] = count;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    // 更新数量
    update_interview_count(status, data) {
      for (let i = 0; i < this.table_data.length; i++) {
        if (data[this.table_data[i]["project_id"]]) {
          this.table_data[i][status] = data[this.table_data[i]["project_id"]];
        } else {
          this.table_data[i][status] = 0;
        }
      }
    },

    window_change() {
      var that = this;
      // <!--把window.onresize事件挂在到mounted函数上-->
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          window.fullWidth = document.documentElement.clientWidth;
          that.windowHeight = window.fullHeight; // 高
          that.windowWidth = window.fullWidth; // 宽
        })();
      };
    },

    open_message_list() {
      console.log(this.$refs);

      this.$Notice.info({
        title: "新消息提示",
        desc: "您收到一条新消息，可在【消息中心】查看，请及时处理哟~",
        duration: 0,
        onClose: function () {
          console.log("关闭");
        },
      });

      audio.play();
      // this.$refs.message_list.open()
    },

    update_component() {
      // 项目信息
      this.$refs.project_basic_info.open(this.project_current_item.project_id);
      // 员工借支
      this.$refs.jiezhi_data.open(
        this.project_current_item.project_id,
        this.project_current_item.project_id.project_name
      );
    },

    click_left_project(item, i) {
      this.project_current_index = i;
      this.project_current_item = item; 1
      this.right_menu_index = 0;
      this.$refs.check.open(this.project_current_item.project_id)
      this.update_interview_num();
      this.updateQueryParam('list_index', i)
    },

    click_swiper_idcard(item) {
      open_new_page('/workbench/swiper_idcard?project_id=' + item.project_id,)
    },

    add_nedd_job() {
      var item = {
        job_name: "",
        need_count: 10,
      }
      this.update_need_job_list.push(item)
    },

    universal_form(item) {
      open_new_page('/tools/universal_form?project_id=' + item.project_id,)

    },

    project_name_long_slice(str) {
      var maxLength = 30; // 最大显示长度（英文字符数）
      var currentLength = 0;
      var result = '';

      for (var i = 0; i < str.length; i++) {
        var char = str[i];
        // 判断是否为中文字符（Unicode范围）
        if (char.charCodeAt(0) > 255) {
          currentLength += 2; // 中文字符占2个长度单位
        } else {
          currentLength += 1; // 英文字符占1个长度单位
        }

        // 如果超出最大长度，添加省略号并终止循环
        if (currentLength > maxLength) {
          result += '...';
          break;
        }

        result += char;
      }

      return result;
    }
  },
};
</script>

<style scoped>
.need_job {
  display: flex;
  padding: 0 5px;
}

.need_job_div2 {
  padding: 5px 10px;
  border: 1px solid #eaeaea;
  margin: 10px 10px 10px 10px;
  border-radius: 3px;
  color: #888
}

.need_job_index {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #0466dd;
  color: #fff;
  width: 25px;
}

.need_job_main {
  max-height: 300px;
  padding-right: 10px;
  overflow: auto;
}

.need_job_btn_div {
  display: flex;
  justify-content: center;
  color: #0466dd;
  cursor: pointer;
  align-items: center;
  padding: 5px;

  background-color: #f2f2f2;

}

.need_job_btn_div:hover {
  background-color: #d8eafb;

}

.del_job {
  background: #ff4f63;
  color: #fff;
  padding: 5px;
  border-radius: 5px;
}

.del_job:hover {
  cursor: pointer;
  opacity: .7;
}

.need_job_box {}

.need_job_div {
  margin: 10px 0;
  padding-bottom: 5px;
  border-bottom: 1px solid #ececec;
  display: flex;
  justify-content: space-between;

}

.need_job_title {
  width: 100px;
  flex-shrink: 0;
  color: #767676
}

.need_job_inner_div {
  display: flex;
  margin-bottom: 5px;
  align-items: end;
}

.contract_span {
  cursor: pointer;
  color: #0466dd;
}

.iconsfz1 {
  font-size: 18px;
  color: #09b72c;
}

.jiance_number {
  /* font-weight: 600; */
  color: #ed0514;
  padding: 0 2px;
}

.jiance_number:hover {
  color: red;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.jiance_number2 {
  /* font-weight: 600; */
  color: #280e10;
  padding: 0 2px;
}

.jiance_div {
  padding: 5px 10px;
  background: rgb(255, 244, 224);
  color: #333;
  font-size: 13px;
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  border-radius: 5px;
}

.jiance_div2 {
  padding: 5px 10px;
  background: rgb(182, 237, 184);
  color: #333;
  font-size: 13px;
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  border-radius: 5px;
}

.main2 {
  display: flex;
  width: 100vw;
  height: 100vh;

}

.left_menu_if {
  width: 270px;
  margin-right: 10px;
  flex-shrink: 0;
}

.tingzhi_hezuo:hover {
  cursor: pointer;
  font-weight: 600;
  color: #fa0c0c;
}

.tingzhi_hezuo {
  font-size: 13px;
  margin-right: 10px;
  cursor: pointer;
  color: #f37a7a;
}

.search_div {
  text-align: center;
  padding: 0 0 10px 10px;
}

.project_name_div2 {
  font-weight: 600;
  font-size: 16px;
  color: #121e5b;
  display: flex;
  align-items: center;
  justify-content: center;
}

.right_project_name {
  cursor: pointer;
  letter-spacing: 2px;
  border-bottom: 1px solid #e9e9e9;
  background: #e7eaee;
  margin-bottom: 5px;
  text-align: center;
  height: 37px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mianshi_box2_name {
  font-size: 13px;
}

.mianshi_box2 {
  height: 65px;
  width: 110px;
  cursor: pointer;
  padding-top: 7px;
  margin: 0px 10px 10px 0;
  background: #fff;
  color: #333;
  border: 1px solid #b8bef7;
  /* box-shadow: 0 0 5px #437fcd; */
  text-align: center;
  border-radius: 5px;
}

.mianshi_box_form {
  height: 65px;
  width: 110px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding-top: 7px;
  margin: 5px 10px 0px 0;
  background: #fff;
  color: #333;
  border: 1px solid #b8bef7;
  /* box-shadow: 0 0 5px #437fcd; */
  text-align: center;
  border-radius: 5px;
}

.mianshi_box_form:hover {
  background: #0466dd;
  color: #fff;
}

.mianshi_box2:hover {
  background: #0466dd;
  color: #fff;
}

.mianshi_box {
  display: flex;
  flex-wrap: wrap;

}

.week_need {
  padding: 10px 15px 0 15px;
  color: #333;
}

.line_name {
  margin-left: 6px;
  color: #333;
  font-weight: 600;
}

.line {
  height: 1px;
  margin: 10px 10px 15px 10px;
  background: #f6f5f5;
}

.line_icon_title {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ececec;
  padding-bottom: 5px;
}

.line_icon {
  height: 15px;
  width: 10px;
  border-radius: 2px;
  background: #0466dd;
}

.current_need_count {
  color: #0466dd;
  cursor: pointer;
}

.right_right {
  padding: 10px;
  background: #fff;
  width: 100%;
  height: 100%;
  overflow: auto;
}

/* .project_right_box_inner {
  width: 100%;
  padding-left: 10px;
  background: orange;
  height: 100%;
} */

.project_right_box_menu_list {
  height: 40px;
  background: #edebeb;
  color: #666666;
  border-radius: 10px 0 0 10px;
  line-height: 40px;
  font-size: 13px;
  padding: 0 3px;
  text-align: center;
  margin-bottom: 5px;
  cursor: pointer;
  display: flex;
  position: relative;
  justify-content: center;
}

.menu_hot {
  width: 23px;
  height: 15px;
  position: absolute;
  top: 1px;
  background-color: red;
  left: 1px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 12px;
  justify-content: center;
}

.project_right_box_menu_list:hover {
  background: #e6e1e1;
}

.project_right_box_menu_list2 {
  height: 40px;
  border-radius: 10px 0 0 10px;
  color: #fff;
  line-height: 40px;
  font-size: 13px;
  font-weight: 600;
  padding: 0 3px;
  text-align: center;
  cursor: pointer;
  margin-bottom: 5px;
  position: relative;
}

.project_right_box_menu {
  width: 110px;
  /* background: rgb(246, 241, 241); */
  background: #f5f7f9;
  height: 100%;
}

.project_right_box2 {
  margin-top: 50px;
  top: 60px;
  padding-left: 10px;
  width: calc(100vw - 10px);
  height: calc(100vh - 60px);
}

.project_right_box {
  position: absolute;
  right: 0px;
  top: 50px;
  width: calc(100% - 270px);
  /* width: calc(100% - 5px); */
  /* width: calc(100vw - 280px); */
  height: calc(100vh - 60px);
  /* background: rgb(255, 255, 255); */
  /* box-shadow: 0 0 3px #f3f2f2; */
}

.project_right_inner {
  display: flex;
  height: calc(100vh - 100px);
}

.left_project_div_list {
  height: calc(100vh - 180px);
  overflow: auto;
}

.project_page {
  border-top: 1px solid #ececec;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.project_name_text {
  font-size: 13px;
}

.project_number {
  width: 25px;
  height: 18px;
  background: #d6dadf;
  color: #fff;
  border-radius: 3px;
  font-size: 11px;
  text-align: center;
  line-height: 18px;
  margin-right: 5px;
}

.project_number2 {
  width: 25px;
  height: 18px;
  background: #ffbf00;
  color: #f1f1f2;
  border-radius: 3px;
  font-size: 11px;
  text-align: center;
  line-height: 18px;
  margin-right: 5px;
}



.top_div {
  display: flex;
  align-items: center;
}

.project_full_name {
  font-size: 12px;
  display: flex;
  color: #bebebe;
  font-weight: 300;
}

.project_list_div_click {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 7px 10px 5px 10px;
  margin: 0 0px;
  background: #0466dd;
  color: #fff;
}

.project_list_div {
  padding: 7px 10px 5px 10px;
  margin: 0 0px;
  display: flex;
  align-items: center;
  cursor: pointer;
  border-bottom: 1px solid #ececec;
}

.left_project_tab {
  display: flex;
  justify-content: center;
}

.project_left_box {
  width: 260px;
  height: calc(100vh - 60px);
  position: absolute;
  left: 0px;
  top: 50px;
  overflow: auto;
  background: rgb(255, 255, 255);
  box-shadow: 0 0 3px #f3f2f2;
}

.project_introduction {
  padding-bottom: 10px;
}

.tab_div {
  padding-left: 10px;
  display: flex;
  justify-content: space-between;
}

.people_count_div {
  text-align: center;
  display: flex;
  align-items: center;
}

.need_update_title {
  border-radius: 5px;
  background-color: #fef3f2;
  color: #333;
  font-size: 13px;
  padding: 5px 10px;
  margin-bottom: 5px;
}

.need_button_div {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.need_count {
  color: #0466dd;
  cursor: pointer;
}

.introjs-tooltiptext {
  font-size: 13px;
  padding: 10px 15px;
}

.introjs-tooltip-title {
  font-size: 16px;
  font-weight: 600;
  color: #0466dd;
}

.introjs-button::after {
  border: none;
  background-color: none;
  background: none;
  color: #0466dd;
}

.introjs-button:active {
  border: none;
  outline: none;
  color: #0466dd;
  background-color: none;
  background: none;
}

.introjs-button:hover {
  border: none;
  outline: none;
  color: #0466dd;
  background-color: none;
  background: none;
}

.introjs-button:focus {
  box-shadow: none;
  border: none;
  background-color: none;
  background: none;
  color: #0466dd;
}

.introjs-button {
  background-color: #c4c4c4;
  border-radius: 5px;
  border: none;
  outline: none;
  color: #0466dd;
  margin: 0;
  padding: 5px 10px;
  outline: none;
  background-color: transparent;
  line-height: inherit;
}

.introjs-skipbutton {
  font-size: 14px;
  font-weight: 300;
  color: #e8e8e8 !important;
}
</style>

<style scoped>
.search_notify {
  font-size: 12px;
  color: #ff5555;
}

.project_name {
  cursor: pointer;
  color: #0466dd;
}

.loading_gif {
  width: 12px;
  height: 12px;
}

.hmc_span {
  display: flex;
  justify-content: space-between;
}

.search_box {
  margin: 0 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.project_type_tag {
  background-color: #ccc;
  padding: 2px 5px;
  margin-right: 5px;
  color: #ffffff;
  border-radius: 3px;
  font-size: 10px;
}

.project_name_div {
  padding-right: 10px;
  font-size: 13px;
  color: #0466dd;
  font-weight: 300;
}

.tabs_div {
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.table_num_title {
  flex-shrink: 0;
  margin-right: 3px;
}

.table_num_div {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.table_click {
  cursor: pointer;
  color: #515a6e;
  width: 100px;
  display: flex;
  align-items: center;
  margin-right: 5px;
}

.table_click:hover {
  color: #0c6ce2;
}

.hmc_span_txt {
  cursor: pointer;
  color: #515a6e;
  margin-right: 10px;
  width: 90px;
  text-align: left;
  display: flex;
  align-items: center;
}

.hmc_span_txt:hover {
  color: #0c6ce2;
}

.table_a {
  cursor: pointer;
  color: #515a6e;
  margin-right: 10px;
  cursor: pointer;
}

.table_a:hover {
  color: #0c6ce2;
}

.table_a_box {
  display: flex;
}

.content_page {
  display: flex;
  justify-content: center;
  padding: 5px;
}

/deep/ .ivu-tabs-bar {
  margin-bottom: 10px;
}

.circular {
  width: 25px;
  height: 25px;
}

.table_box {
  position: relative;
  background-color: #fff;
  padding: 10px 10px 0 10px;
  border-radius: 5px;
}

.add_sys_button {
  margin-top: 20px;
  text-align: right;
}

.form_item_title {
  flex-shrink: 0;
  width: 100px;
}

.form_item {
  display: flex;
  align-items: center;
}

.options {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.content {
  width: 100%;
  position: absolute;
  right: 0px;
  top: 50px;
  height: calc(100vh - 50px);
}

.main {
  background: #f5f7f9;
  min-height: 100vh;
}
</style>
